<p-pickList
	[source]="medias"
	[target]="selectedMedias"
	[stripedRows]="true"
	filterBy="name"
	sourceHeader="Disponibles"
	targetHeader="Seleccionados"
	(onMoveAllToSource)="removeFromTarget($event)"
	(onMoveToSource)="removeFromTarget($event)"
	(onMoveToTarget)="moveToTarget($event)"
	(onMoveAllToTarget)="moveToTarget($event)"
	class="reel-medias"
	>
	<ng-template let-media pTemplate="item">
		<div class="media-item" [class.disabled-item]="!media.vigente">

			<div class="image-container">
				<p-image [preview]="true" *ngIf="data.type === 'IMAGE'" src="{{media.resource_url}}"></p-image>
				<img *ngIf="data.type === 'VIDEO'" class="thumb-video" (click)="openVideo(media)" src="{{media.thumb_url}}">
			</div>
			<div class="media-list-detail">
				<h5 class="mb-2">{{media.name}}</h5>
				<!-- <span class="media-description">{{media.description}}</span> -->
				<span>{{media.date}}</span>
				<span *ngIf="!media.vigente" class="badge badge-danger ml-2">No vigente</span>
			</div>

		</div>
	</ng-template>
</p-pickList>


<div class="modal-footer">
    <button class="btn btn-success" (click)="submit()"><i class="fa fa-save"></i> Guardar</button>
    <button class="btn btn-danger" (click)="modalRef.hide()"><i class="fa fa-times"></i> Cancelar</button>
</div>
